import { GraphQLClient } from "graphql-request";
import Head from "next/head";
import Layout, { siteTitle } from "../../components/layout";
import Profile from "../../components/Profile";
import Gallery from "../../components/Gallery";

const graphcms = new GraphQLClient(process.env.GRAPHQL_URL_ENDPOINT);

export async function getServerSideProps(context) {
  const { man } = await graphcms.request(
    `
    query Man($slug: String!) {
      man(where: { slug: $slug }) {
        id
        number
        photoPrincipale {
            url
            fileName
            width
            height
            imgPosition
        }
        region
        anneeDeNaissance
        taille
        type
        job
        otherSkills
        like
        dislike
        gallery {
            url
            width
            height
            imgPosition
        }
      }
    }
  `,
    {
      slug: context.query.slug,
    }
  );

  return {
    props: {
      man,
    },
  };
}

const Woman = ({ man }) => {
  return (
    <Layout>
      <Head>
        <title>{`${siteTitle} Man ${man.number}`}</title>

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicons/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicons/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicons/favicon-16x16.png"
        />
        <link rel="manifest" href="/favicons/site.webmanifest" />
        <link
          rel="mask-icon"
          href="/favicons/safari-pinned-tab.svg"
          color="#000000"
        />
        <link rel="shortcut icon" href="/favicons/favicon.ico" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta
          name="msapplication-config"
          content="/favicons/browserconfig.xml"
        />
        <meta name="theme-color" content="#ffffff"></meta>

        <meta name="title" content="Kaleidoscope Agency" />
        <meta
          name="description"
          content="Kaleidoscope agency is constantly looking for new faces and recruits actors, models, athletes, atypical profiles and other people/face profiles."
        />
        <meta
          name="keywords"
          content="kaleidoscope-agency,kaleidoscope,agency,model,new,faces,recruits,actors,actor,model,athletes,athlete,atypical,profile,profiles,women,woman,men,man,tv,fiction,pub,"
        />
        <meta name="robots" content="index, follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="author" content="Virginie Miesse" />
      </Head>

      <Profile person={man} />

      <Gallery items={man.gallery} type="profile" gender="men" canZoom />
    </Layout>
  );
};

export default Woman;
